/**
 * Find all groups with conditional data attribute, parse its conditionals and update its children state based on value of provided selectors
 * @param {HTMLFormElement} formElement
 */
function refreshConditionalRelatedElements(formElement) {
	// Find all elements with `data-show-if` attribute
	formElement.querySelectorAll('[data-show-if]').forEach((groupElement) => {

		// Parse data-show-if attribute string into object
		const parsedGroupData = parseConditionalGroup(groupElement);

		// Find all input elements which are responsible (their value) for this group visibility
		const handledGroupSelectors = getGroupSelectors(parsedGroupData, formElement);

		handledGroupSelectors.forEach((element) => {
			if (!element) return;

			updateGroupVisibility(parsedGroupData, groupElement, formElement);
		});

	})
}

/**
 * Update group visibility and disable/enable all inputs inside to prevent from submitting "hidden" fields
 * @param {ParsedGroupData} parsedGroupData
 * @param {HTMLElement} groupElement
 * @param {HTMLFormElement} formElement
 */
function updateGroupVisibility(
	parsedGroupData,
	groupElement,
	formElement
) {
	const shouldAppear = checkParsedGroup(parsedGroupData, formElement);
	groupElement.style.display = !shouldAppear ? 'none' : '';
	groupElement.classList.toggle('field-group--inactive', !shouldAppear);

	// Chech if its group within group
	const hasParentGroupInactive = !!groupElement.closest('.field-group.field-group--inactive');

	const inputs = groupElement.querySelectorAll('[name]');
	for (const input of inputs) {
		// Disable input if parent group is disabled
		const shouldInputAppear = hasParentGroupInactive ? false : !input.closest('.field-group').classList.contains('field-group--inactive');
		toggleFieldVisibility(input, shouldInputAppear);
		input.classList.toggle('input--inactive-by-group', !shouldInputAppear);
	}
}
